import * as React from "react";
import {Routes, Route, BrowserRouter, Navigate} from "react-router-dom";
import "./App";
import MenuBar from "./components/MenuBar";
import RegistrationDialog from "./components/RegistrationDialog";
import AllMusics from "./views/AllMusics";
import Community from "./views/Community";
import Home from "./views/Home";
import OurBrand from "./views/OurBrand";
import TestPage from "./views/TestPage";
import LogInDialog from "./components/LogInDialog";
import Page404 from "./views/page404";
import MusicUploadButton from "./components/MusicUpload";
import {ThirdwebProvider} from "@thirdweb-dev/react";


export default function App() {
  return(
      <ThirdwebProvider
          // Required configuration for the provider, but doesn't affect Auth.
          activeChain="ethereum"
          authConfig={{
              // Set this to your domain to prevent phishing attacks
              domain: "leptonmusic.com",
              // The URL of your Auth API
              authUrl: "/api/auth",
          }}
      >
          <div className="App">

              <BrowserRouter>
                  <MenuBar />
                  <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="all-musics" element={<AllMusics />} />
                      <Route path="community" element={<Community />} />
                      <Route path="brand" element={<OurBrand />} />
                      <Route path="registration" element={<RegistrationDialog />} />
                      <Route path="test" element={<TestPage />} />
                      <Route path="music-upload" element={<MusicUploadButton />} />
                      <Route path="login" element={<LogInDialog />} />
                      <Route path="404" element={<Page404 />} />
                  </Routes>
              </BrowserRouter>


          </div>
      </ThirdwebProvider>

  )
}